// ServicesTrustedAcrossIndustriesData.js

// FINANCE AUDIT AND ASSURANCE PATHS
export const financialStatementAuditData = {
  industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
  ],
  heading: "SECTOR EXPERTISE",
  subheading: "AUDITS TAILORED FOR EVERY INDUSTRY",
  description:
    "Every industry runs differently, so the risks inside each business look different too. That’s why we start by understanding how your sector works – how money flows, where common issues appear, and what regulators expect.",
  buttonText: "Explore Our Industries",
};

// IFRS ADVISORY SERVICE
export const ifrsAdvisoryServiceData = {
  industries: [
    { title: "Banking", img: "/assets/icons/financial.png" },
    { title: "Media", img: "/assets/icons/Technology.png" },
    { title: "Logistics", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "INDUSTRY INSIGHTS",
  subheading: "SECTOR-SPECIFIC IFRS EXPERIENCE",
  description:
    "IFRS interpretation varies from revenue models in media to lease-heavy structures in logistics and financial instruments in banking. Our industry-trained team understands these nuances and designs reporting frameworks that reflect the economic reality of your business.",
  buttonText: "Explore Our Industries",
};

// OTHER ASSURANCE SERVICE
export const otherAssuranceServiceData = {
  industries: [
    { title: "Banking", img: "/assets/icons/financial.png" },
    { title: "Telecom", img: "/assets/icons/Technology.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Manufacturing", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "INDUSTRY EXPERTISE",
  subheading: "ASSURANCE ACROSS DIVERSE SECTORS",
  description:
    "Assurance needs shift dramatically across industries - what matters in banking wouldn’t drive credibility in telecom, healthcare, or manufacturing. Our team brings experience across fast-moving and asset-heavy sectors by adapting our testing, validation and reporting methods to each risk landscape.",
  buttonText: "Explore All",
};

// INTERNAL CONTROL FRAMEWORK
export const internalControlFrameworkData = {
  industries: [
    { title: "Banks", img: "/assets/icons/financial.png" },
    { title: "Manufacturers", img: "/assets/icons/Real-Estate.png" },
    { title: "Telecom", img: "/assets/icons/Technology.png" },
  ],
  heading: "INDUSTRY YOU OPERATE",
  subheading: "SECTOR-SPECIFIC FRAMEWORKS",
  description:
    "Banks need automated approval logic. Manufacturers need operational safeguards and so on. Every industry comes with unique risk behavior, and our frameworks come with solutions. The result: controls that don’t just exist - they function.",
  buttonText: "Discover More",
};
export const dealAdvisoryData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "SECTOR-DRIVEN PERSPECTIVE",
  subheading: "DEALS THAT UNDERSTAND INDUSTRY DNA",
  description:
    "Our experience across technology, BFSI, healthcare, energy, real estate, consumer, manufacturing, logistics, and emerging digital markets helps us evaluate deals through industry logic, not just spreadsheets.",
  buttonText: "There’s More",
};
export const restructuringData = {
  industries: [
      { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "MULTIPLE REALITIES",
  subheading: "RESTRUCTURING LOGIC FOR BUSINESS MODEL",
  description:
    "Manufacturing demands capacity optimization, retail hinges on cash cycles, tech needs churn management, construction relies on project velocity, and BFSI restructures around regulatory confidence.",
  buttonText: "There’s More",
};
export const dueDiligenceData = {
  industries: [
      { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "SECTOR EXPOSURE",
  subheading: "OUR DILIGENCE INDUSTRIES",
  description:
    "We apply due diligence across manufacturing, tech, energy, real estate, logistics, retail, BFSI, healthcare, and more - each with different risk DNA.",
  buttonText: "Explore More",
};
export const forensicServicesData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "SECTOR-WIDE FORENSIC WORK",
  subheading: "EXPERIENCE ACROSS HIGH-RISK ENVRIONMENTS",
  description:
    "We have conducted forensic work for businesses facing fraud suspicion, shareholder disputes, cyber infiltration, partner conflict, vendor collusion, and cash-flow leakages across sectors.",
  buttonText: "Discuss a Case",
};
export const riskAdvisoryData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "RISK ACROSS INDUSTRIES",
  subheading: "EXPERIENCE ACROSS DIFFERENT INDUSTRIES",
  description:
    "We have assisted organizations with enterprise risk, cyber readiness, governance frameworks, compliance preparedness, operational stability and continuity planning — across scale, sectors and ownership models.",
  buttonText: "Solve Your Risk",
};
export const technologyAdvisoryServiceData = {
  industries: [
   { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "DIGITAL EXPERIENCE",
  subheading: "TECH ADVISORY ACROSS SECTORS",
  description:
    "We have led digital improvement cycles across mid-market and enterprise environments — from financial services and retail to telecom, government, healthcare & manufacturing.",
  buttonText: "Start Digital Shift",
};
export const valuationsData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "OUR INDUSTRY DEPTH",
  subheading: "INSIGHT ACROSS MARKETS",
  description:
    "Our valuation analysts bring experience across manufacturing, retail, BFSI, PE-backed firms, tech startups, healthcare, logistics, and more.",
  buttonText: "Discuss More",
};



// TAXATION DATA ARRAYS
export const corporateTaxData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "SECTOR TAX INTELLIGENCE",
  subheading: "TAX OPERATES ACROSS INDUSTRIES",
  description:
    "We work with businesses across manufacturing, trading, financial services, technology, healthcare, and cross-border operations — allowing us to structure tax models.",
  buttonText: "Explore Tax Expertise",
};

export const mergerAndAcquisitionData = {
  industries: [
     { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "EXPERIENCE ACROSS MARKETS",
  subheading: "TAX ADVISORY FOR BUSINESSES",
  description:
    "We support acquisitions, spin-offs, joint ventures and internal reorganizations across manufacturing, technology, real estate, FMCG, energy, healthcare and multi-nationals.",
  buttonText: "Request a Consultation",
};

export const transferPricingData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "WHERE WE OPERATE",
  subheading: "CROSS-SECTOR EXPERTISE & EXECUTION",
  description:
    "We support global groups across manufacturing, IT, BFSI, pharma, distribution & engineering. Each engagement strengthens pricing transparency while reducing reassessment risk across borders.",
  buttonText: "See Case Experience",
};

export const valueAddedTaxData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "SECTOR COVERAGE",
  subheading: "VAT ACROSS DIVERSE MODELS",
  description:
    "Manufacturing input credits, real-estate exemptions, trading reverse-charges, digital service taxation, e-commerce invoice flow — VAT behaves differently in every industry.",
  buttonText: "Our VAT Case Work",
};


export const internationalTaxData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "ACROSS MARKETS & MODELS ",
  subheading: "TAX EXPERTISE IN DIVERSE SECTORS ",
  description:"Our experience spans manufacturing, IT, trading, digital services, retail, investment structures, and emerging global setups. We understand operational realities and refine tax pathways that work in the real world.",
  buttonText: "Explore Case Insights",
};

export const exciseTaxData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "ACROSS REGULATED SECTORS",
  subheading: "INDUSTRY EXPERTISE WITH EXCISE COMPLEXITY",
  description:
    "We have partnered with manufacturers, importers, FMCG players, automotive suppliers, tobacco & energy-linked businesses, navigating excise in multi-state conditions.",
  buttonText: "Consult Experts Now",
};

export const taxRestructuringData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "EXPERIENCE THAT DELIVERS",
  subheading: "ACROSS DIFFERENT BUSINESS MODELS",
  description:
    "We have re-engineered tax structures for conglomerates, trading houses, manufacturers, offshore holding units, retail distributors & diversified group entities.",
  buttonText: "Explore Possibilities",
};


export const economicSubstanceRegulationsData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "PROVEN ACROSS SECTORS",
  subheading: "ESR FOR DIFFERENT INDUSTRIES",
  description:
    "We have supported ESR readiness for holding companies, distribution hubs, investment groups & multinational subsidiaries. Our work reduces penalties, improves governance control and strengthens authority confidence during verification.",
  buttonText: "Require ESR Support?",
};

export const financeAndAccountingData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "PROVEN ACCOUNTING EXPERTISE",
  subheading: "INDUSTRIES WE STRENGTHEN FINANCIALLY",
  description:
    "We have managed books, compliances, cost structures and reporting cycles for businesses with realities — retail-driven, contract-based, high-volume trading, manufacturing, etc.",
  buttonText: "Discuss Your Requirements!",
};
export const corporateAdvisoryServicesData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "WHO WE’VE ADVISED",
  subheading: "DECISIONS ACROSS MULTIPLE SECTORS",
  description:
    "We have supported startups scaling internationally, mid-market companies restructuring post-pandemic, and established corporations entering new markets or revisiting capital strategy. Our advisory helps organizations choose wisely, scale sustainably, and protect enterprise value at every stage.",
  buttonText: "Let’s Discuss",
};
export const expensesClaimManagementData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "SECTOR REACH",
  subheading: "EXPERIENCE ACROSS DIVERSE BUSINESS MODELS",
  description:
    "We have supported SMEs, corporates, family-owned businesses, and global enterprises in navigating complex reimbursement structures. Our experience ensures delivering faster claim cycles and improved cost visibility.",
  buttonText: "Explore Case Studies",
};
export const payrollHrServicesData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "ACROSS DIVERSE SECTORS",
  subheading: "TRUSTED PAYROLL & HR SUPPORT",
  description:
    "Our team manages large and small payroll structures across industries such as retail, professional services, F&B, logistics, healthcare, and technology.",
  buttonText: "Speak to Experts",
};
export const secondmentData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "SECTOR EXPERTISE",
  subheading: "TRUSTED SECONDMENT SUPPORT",
  description:
    "Our secondees have supported organizations in banking, real estate, manufacturing, retail, technology, and government sectors to deliver reporting, compliance, and operational support without disruption.",
  buttonText: "Explore Industry Experience",
};
export const treasuryServiceData = {
  industries: [
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "PROVEN ACROSS INDUSTRIES",
  subheading: "TREASURY EXPERTISE FOR COMPLEX BUSINESSES",
  description:
    "Our team understands the compliance expectations, banking practices, and risk patterns unique to each industry — making our solutions adaptable and reliable across sectors.",
  buttonText: "Explore Industry Expertise",
};
// STRATEGIES
export const marketResearchData = {
 industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
  ],
  heading: "PROVEN EXPERTISE",
  subheading: "RESEARCH STRENGTH ACROSS INDUSTRIES",
  description: "Our experience across emerging and mature markets allows us to understand behavioural differences, regulatory landscapes, and industry complexities — helping you navigate markets confidently.",
  buttonText: "Explore Industry Insights",
};

export const businessConsultingData = {
 industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
  ],
  heading: "SECTOR EXPERTISE",
  subheading: "EXPERTISE FOR YOUR INDUSTRY",
  description: "Our consultants bring hands-on experience across industries. Each strategy is grounded in real market behaviour, regulatory dynamics, and operational realities.",
  buttonText: "Explore Industry Experience",
};

// CORPORATE SERVICES
export const entitySetupData = {
  industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
  ],
  heading: "CROSS-INDUSTRY EXPERTISE",
  subheading: "ENTITY SETUP FOR EVERY BUSINESS",
  description: "We have supported company formation across industries, including trading, manufacturing, technology, finance, healthcare, logistics, and professional services.",
  buttonText: "Explore Corporate Services",
};

export const outsourcedFinanceRegulatoryComplianceData = {
 industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
  ],
  heading: "CROSS-SECTOR EXPERTISE",
  subheading: "COMPLIANCE SOLUTIONS FOR EVERY INDUSTRY",
  description: "Our experience spans regulated sectors with different finance and compliance expectations, tailoring frameworks to meet them with speed & accuracy.",
  buttonText: "Our Industry Capabilities",
};

export const companySecretarialData = {
  industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technology", img: "/assets/icons/Technology.png" },
    { title: "Real Estate", img: "/assets/icons/Real-Estate.png" },
    { title: "Healthcare", img: "/assets/icons/health.png" },
  ],
  heading: "OUR GOVERNANCE RECORD",
  subheading: "TRUSTED BY DIVERSE INDUSTRIES",
  description: "We support businesses with different governance structures, regulatory pressures, and ongoing corporate changes, delivering consistent compliance and operational clarity.",
  buttonText: "Explore Our Experience",
};
